import _get from 'lodash/get';
import _isString from 'lodash/isString';
export function getCuratedHeroConfiguration(componentConfigurations, componentIdentifier) {
  return componentConfigurations.find(function (_ref) {
    var currentComponentIdentifier = _ref.componentIdentifier;
    return currentComponentIdentifier === componentIdentifier;
  });
}
export function getContentNodeContent(contentNodes) {
  return _get(contentNodes, '[0].content', '');
}
export function getImageSource(image) {
  if (_isString(image)) {
    return image;
  }
  return _get(image, 'gatsbyFile') || _get(image, 'file');
}
export function getImageAltText(image) {
  return _get(image, 'altText', '');
}